import { ChangeEvent } from 'react';
import { IconButton, Stack, Textarea } from '@chakra-ui/react';
import { SendHorizonal } from 'lucide-react';
import { iconSize } from '@duke-hq/ui/constants/scalable';

// -- ConversationReplyInput ----------------------------------------------------
// The learner reply input bar, shared between the student runtime and the admin
// previews so its appearance can't drift. Controlled: the caller owns the value
// and the submit handler.
export function ConversationReplyInput({
  value,
  onChange,
  onSubmit,
  placeholder = 'Send a message...',
}: {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder?: string;
}) {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value);
  return (
    <Stack
      flexDir="row"
      bg="bg.surface"
      p="2"
      justifyContent="flex-end"
      alignItems="center"
      gap="2"
      alignSelf="stretch"
      borderTop="1px"
      w="100%"
      mt={4}
      borderColor="border.default"
      fontSize="md"
    >
      <Textarea
        value={value}
        onChange={handleChange}
        _placeholder={{ alignItems: 'center' }}
        resize="none"
        minH="8"
        size="sm"
        variant="unstyled"
        fontSize="md"
        placeholder={placeholder}
      />
      <IconButton onClick={onSubmit} size="sm" aria-label="send message" variant="ghost">
        <SendHorizonal color="gray" size={iconSize.lg} />
      </IconButton>
    </Stack>
  );
}
